import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { LogService } from '../../../_shared/log.service'
import { BranchService } from '@app/_services/masters/branch.service';
import { first } from 'rxjs/operators';
import { branch } from '@app/_models/branch';
import { Subject } from 'rxjs';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-branch-master',
  templateUrl: './branch-master.component.html',
  styleUrls: ['./branch-master.component.css']
})
export class BranchMasterComponent implements OnInit {


  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  @ViewChild('showModalDeleteBox', { read: TemplateRef }) showModalDeleteBoxTemplate: TemplateRef<any>;
  
  getresponse: any;
  branch: branch[];
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  branchId: number;
  delMessage: string;

  constructor(private modalService: NgbModal, config: NgbModalConfig, private eventService: LogService, private branchService: BranchService) { }

  callRoute(dataValue) {
    this.eventService.emit<string>(dataValue);
  }

  passData(dataValue, data) {
    this.eventService.emit({ dataValue, data });
  }

  ngOnInit(): void {

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true
    };
    this.branchService.getBranch()
      .pipe(first())
      .subscribe(
        data => {
          console.log("branch response---", data)
          this.branch = data.respData;
          this.dtTrigger.next();
        },
        error => {
          console.log(error)
        }
      )
  }



  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('20');
  }

  deleteBranch(id) {
    this.branchId = id;
    this.modalService.open(this.showModalDeleteBoxTemplate);
  }

  deleteBrn() {
    this.branchService.deleteBranch(this.branchId)
      .pipe(first())
      .subscribe(
        data => {
          console.log("Branch response---", data)
          this.getresponse = data;

          if (this.getresponse.respMessage == "Success") {
            this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
            this.modalService.open(this.showModalBoxTemplate);
            this.branchService.getBranch()
              .pipe(first())
              .subscribe(
                data => {
                  this.delMessage="Branch Deleted Successfully."
                  console.log("Branch response---", data)
                  this.branch = data.respData;
                  //this.dtTrigger.next();
                },
                error => {
                  console.log(error)
                }
              )
          }
          else if (this.getresponse.respMessage == "Failure") {
            this.delMessage=this.getresponse.respData
            this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
            this.modalService.dismissAll(this.showModalBoxTemplate);
          }
        },
        error => {
          console.log(error)
        }
      )
  }
}
